module.exports = __webpack_public_path__ + "static/media/sub-card-label-11.b4c2277a.svg";